import styled from "styled-components";
import ReactSVG from "react-svg";
import Link from "gatsby-link";
import { fromThemeProps } from "../../../helpers/utilities";
import { flex } from "../../../helpers/mixins";
import { A } from "../elements";
import media from "../../../helpers/media";

const StyledFooter = styled.div`
  ${flex({ dir: "column", jc: "space-between" })};
  width: 100%;

  background: ${fromThemeProps("black")};
  transition: 0.4s linear;
`;

StyledFooter.Container = styled.div`
  width: 100%;
  max-width: 50em;
  margin: 0 auto;
`;

StyledFooter.ColToRow = styled.div`
  ${flex({ dir: "column", jc: "space-between", ai: "flex-start" })};
  width: calc(100% - 8em);
  padding-top: 1em;
  padding-left: 4em;

  ${media.xs`
  ${flex({ dir: "row", jc: "space-between", ai: "center" })};
  `}
`;

StyledFooter.LinkList = styled.div`
  ${flex({ dir: "column", jc: "space-between" })};
  padding: 1em 0;
`;

StyledFooter.Link = styled(Link)`
  padding: 0.5em;
  padding-left: 0;

  color: ${fromThemeProps("gray")};
  font-family: ${fromThemeProps("aFont")};
  font-weight: ${fromThemeProps("aWeight")};
  font-size: ${fromThemeProps("footerFontSizeMobile")};

  &:last-child {
    padding-bottom: 0;
  }

  &:hover {
    text-decoration: underline;
  }

  ${media.xs`
      font-size: ${fromThemeProps("footerFontSizeDesktop")};
`}
`;

StyledFooter.Button = styled(StyledFooter.Link)``;

StyledFooter.HR = styled.hr`
  color: ${fromThemeProps("gray")};
  width: 80%;
`;

StyledFooter.SVG = styled(ReactSVG)`
  width: 150px;
  margin-left: 0.5em;
`;

export default StyledFooter;



// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledFooter.js